/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataResponse_DashboardMessages_ } from "../models/DataResponse_DashboardMessages_";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class DashboardService {
  /**
   * Get Dashboard Messages
   * Returns contextual dashboard messages based on current UK time.
   *
   * Includes:
   * - Greeting (Good morning/afternoon/evening, {name})
   * - Title and message (meal moment or companion moment based on time)
   * @param xUserId
   * @returns DataResponse_DashboardMessages_ Successful Response
   * @throws ApiError
   */
  public static getDashboardMessagesApiV1DashboardMessagesGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_DashboardMessages_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dashboard/messages",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
